// Browser-side cache for API results so navigating between pages is instant
// (no refetch within the TTL). Held in memory only — cleared on refresh/reload.
const TTL_MS = 5 * 60 * 1000; // 5 minutes
const store = new Map(); // key -> { data, expiresAt }

// Stable key for a request. Must match how useApiData and prefetch build it.
export function cacheKey(path, params) {
  return `${path}|${JSON.stringify(params || {})}`;
}

export const dataCache = {
  get(key) {
    const hit = store.get(key);
    if (hit && hit.expiresAt > Date.now()) return hit.data;
    if (hit) store.delete(key); // expired
    return undefined;
  },
  set(key, data) {
    store.set(key, { data, expiresAt: Date.now() + TTL_MS });
  },
  clearAll() {
    store.clear();
  },
};

// After a manual Refresh, briefly tell fetches to also bypass the SERVER cache
// (via ?refresh=1) so the user truly gets fresh data, not a server-cached copy.
let bypassUntil = 0;
export function markServerBypass() {
  bypassUntil = Date.now() + 3000; // covers the immediate refetch cycle
}
export function isServerBypass() {
  return Date.now() < bypassUntil;
}
